(function () {
  const navToggle = document.querySelector("[data-nav-toggle]");
  const nav = document.querySelector("[data-site-nav]");
  const header = document.querySelector(".site-header");

  // Plain scroll listener (not IntersectionObserver/rAF) — a single
  // boolean flip is cheap enough not to need throttling, and this avoids
  // the background-tab throttling that rAF-driven approaches can hit.
  //
  // Two thresholds (enter higher than exit), not one — .is-scrolled
  // shrinks the header's own height (padding/font-size, see theme.css),
  // and the header sticks inside #shopify-section-header, so that shrink
  // shifts the page's layout right at the scroll boundary. Chrome's
  // scroll anchoring then nudges window.scrollY to compensate for the
  // shift, which with a single threshold could push scrollY back across
  // that same line — re-triggering this listener, undoing the shrink,
  // shifting layout again, and so on in a fast toggle loop whenever a
  // scroll happened to land near the boundary. The gap between the two
  // thresholds below (40px) is comfortably larger than the shrink's own
  // height delta (~16px), so that compensating nudge can never carry
  // scrollY across both lines at once and restart the loop.
  if (header) {
    const SCROLL_THRESHOLD_ENTER = 80;
    const SCROLL_THRESHOLD_EXIT = 40;
    let isScrolled = false;
    function updateHeaderScrollState() {
      const shouldBeScrolled = isScrolled
        ? window.scrollY > SCROLL_THRESHOLD_EXIT
        : window.scrollY > SCROLL_THRESHOLD_ENTER;
      if (shouldBeScrolled === isScrolled) return;
      isScrolled = shouldBeScrolled;
      header.classList.toggle("is-scrolled", isScrolled);
    }
    updateHeaderScrollState();
    window.addEventListener("scroll", updateHeaderScrollState, { passive: true });
  }

  function closeNav() {
    if (!nav) return;
    nav.classList.remove("is-open");
    if (navToggle) navToggle.setAttribute("aria-expanded", "false");
    nav.querySelectorAll(".has-dropdown.is-open").forEach((li) => {
      li.classList.remove("is-open");
      const toggle = li.querySelector("[data-dropdown-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    });
  }

  if (navToggle && nav) {
    navToggle.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  // The chevron button toggles the submenu without navigating — the
  // parent link (e.g. "Catalog") still works as a normal link on its own.
  document.querySelectorAll("[data-dropdown-toggle]").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const li = button.closest(".has-dropdown");
      if (!li) return;
      const isOpen = li.classList.toggle("is-open");
      button.setAttribute("aria-expanded", String(isOpen));
    });
  });

  document.addEventListener("click", (event) => {
    if (!nav || !nav.classList.contains("is-open")) return;
    if (nav.contains(event.target) || (navToggle && navToggle.contains(event.target))) return;
    closeNav();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeNav();
  });

  // Clicking the logo or any header link that points to the homepage
  // (a real navigation, not browser back/forward) drops the in-progress/
  // completed search so landing back on a "fresh" homepage doesn't still
  // show old results. Same sessionStorage key ai-search.js's
  // restoreState() reads on load — see its SEARCH_STATE_KEY comment.
  // Only clearing on an actual click (not on popstate/bfcache restore)
  // means navigating to Catalog/About and hitting Back still restores the
  // search, since that path never runs this handler.
  if (header) {
    const homeUrl = header.dataset.homeUrl;
    if (homeUrl) {
      header.querySelectorAll('a[href]').forEach((link) => {
        if (link.getAttribute("href") === homeUrl) {
          link.addEventListener("click", () => {
            try {
              sessionStorage.removeItem("pieceworkSearchState");
            } catch (err) {}
          });
        }
      });
    }
  }
})();
